import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MenuSection from "@/components/MenuSection";
import WhyLove from "@/components/WhyLove";
import SocialProof from "@/components/SocialProof";
import Footer from "@/components/Footer";
import OrderForm from "@/components/OrderForm";
import StickyMobileOrder from "@/components/StickyMobileOrder";

export default function Landing() {
  useEffect(() => {
    document.title = "Gullway Nibs — Best in the South East";
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", "Gullway Nibs — Taste of NZ nibbles, born in Burn City. Crispy, addictive, fortnightly drops in the South East. Order now.");

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in-view");
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="App relative" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <div className="reveal"><MenuSection /></div>
        <div className="reveal"><WhyLove /></div>
        <div className="reveal"><SocialProof /></div>
      </main>
      <Footer />
      <StickyMobileOrder />
      <OrderForm />
    </div>
  );
}
